import React, { useState, useCallback } from 'react';
import Layout from 'components/layout';
import type { HomePageProps } from '../index';
import CommercialHeader from 'components/header/commercial';
import dynamic from 'next/dynamic';
import LoadingSpinner from 'components/loading-spinner';
import Benefits from 'components/commercial/benefits';
import GetInTouch from 'components/commercial/get-in-touch';
import SearchOurProperties from 'components/commercial/search-our-properties';
import AutoplaySlides from 'components/autoplay-slides';
import { expCommercialTenant } from 'tenants/definitions/exp-commercial.tenant';
import Quote from 'components/quote';
import CommercialMetrics from 'components/commercial/metrics';

const CommercialHero = dynamic(() => import('components/commercial/hero'), {
  ssr: false,
  loading: () => <div style={{ width: '100vw', height: '100vh' }}><LoadingSpinner /></div>,
});

// We need to memoize the hero so that it doesn't re-render when the header is shown/hidden
const MemoizedCommercialHero = React.memo(CommercialHero);

export default function HomePageExpCommercial({ routeName }: HomePageProps) {
  const [showHeader, setShowHeader] = useState(true);
  const namespace = expCommercialTenant.config.expCommercial?.namespace;

  const commercialBenefits = expCommercialTenant.config.commercialBenefits;
  const tenantConfig = expCommercialTenant.config.home;
  const quoteConfig = expCommercialTenant.config.expCommercial?.leoQuoteConfig;
  const metrics = expCommercialTenant.config.metrics;

  const handleMinScale = useCallback(() => {
    setShowHeader(true);
  }, []);

  const handleEnter = useCallback(() => {
    setShowHeader(false);
  }, []);

  const handleLeave = useCallback(() => {
    setShowHeader(true);
  }, []);
  
  return (
    <Layout routeName={routeName} showMobileBottomNav={false} renderHeader={() => <CommercialHeader showHeader={showHeader} />}>
      <MemoizedCommercialHero  
        onMinScale={handleMinScale}
        onEnter={handleEnter}
        onLeave={handleLeave}
      />
      <Benefits {...commercialBenefits} />
      <SearchOurProperties {...tenantConfig.searchOurProperties} />
      <AutoplaySlides {...tenantConfig.autoplaySlides} />
      <Quote namespace={namespace} {...quoteConfig} />
      <CommercialMetrics metrics={metrics} />
      <GetInTouch />
    </Layout>
  );
}
